<div class="layout-col full">
  <app-item-sort-property-table
    class="flex"
    [sortProperties]="(itemSortSpec$ | async).properties"
    (sortPropertiesChange)="onSortPropertiesChange($event)"
  >
  </app-item-sort-property-table>
</div>
